import { put, delay, fork, cancel, takeEvery } from "redux-saga/effects";
import {
    REGISTER_ACTIVITY,
    REGISTER_MENU_ACTIVITY,
    TOGGLE_TIMEOUT_ACTIVE,
    TOGGLE_TIMEOUT_DISABLED,
} from "../../actions/timeoutActions";
import { OPEN_SIDE_MENU } from "../../actions/sideMenuActions";
import { ACTIVATE_ITEM } from "../../actions/configurationActions";

function* resetAndStartTimeout(interval: number) {
    yield delay(interval);
    yield put({
        type: OPEN_SIDE_MENU,
        sideMenuOpen: false,
    });
}

export function* triggerTimeout(): any {
    let timeout = yield fork(resetAndStartTimeout, 30000);
    let triggerIsActive = true;

    yield takeEvery([TOGGLE_TIMEOUT_ACTIVE, TOGGLE_TIMEOUT_DISABLED], function* (v): any {
        yield cancel(timeout);
        triggerIsActive = v.type === "TOGGLE_TIMEOUT_ACTIVE";
        if (triggerIsActive) timeout = yield fork(resetAndStartTimeout, 30000);
    });

    yield takeEvery([ACTIVATE_ITEM, REGISTER_MENU_ACTIVITY], function* (): any {
        yield cancel(timeout);
        if (triggerIsActive) timeout = yield fork(resetAndStartTimeout, 6000);
    });
    yield takeEvery(REGISTER_ACTIVITY, function* (): any {
        yield cancel(timeout);
        if (triggerIsActive) timeout = yield fork(resetAndStartTimeout, 30000);
    });
}
